import { render } from "./states-list.vue?vue&type=template&id=5d5d5b52"
import script from "./states-list.vue?vue&type=script&lang=js"
export * from "./states-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__